module.exports = __webpack_public_path__ + "img/shrimp_th_new_0002.84524fb8.png";